import { c as _c } from "react/compiler-runtime";
export const ArrowUp = t0 => {
  const $ = _c(4);
  const {
    className,
    style
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M3.45064 0.0217385C3.58993 0.0575077 3.72731 0.136711 3.84206 0.252245L6.3304 2.75764C6.46332 2.89148 6.54803 3.05616 6.57279 3.21895C6.59753 3.38154 6.56279 3.55312 6.44017 3.67658C6.31735 3.80024 6.14622 3.83552 5.98387 3.81048C5.82154 3.78545 5.6577 3.69988 5.52479 3.56606L3.88354 1.91356V9.07217C3.88354 9.26112 3.82788 9.43785 3.73095 9.57074C3.6341 9.70351 3.48853 9.80058 3.31436 9.80058C3.1402 9.80058 2.99462 9.70351 2.89778 9.57074C2.80085 9.43785 2.74519 9.26112 2.74519 9.07217V1.86457L1.05548 3.56586C0.922572 3.69967 0.758729 3.78524 0.596397 3.81028C0.434055 3.83531 0.262922 3.80003 0.140105 3.67637C0.0174819 3.55291 -0.0172559 3.38133 0.00747576 3.21874C0.0322368 3.05596 0.116948 2.89127 0.249869 2.75744L2.73822 0.252039C2.8564 0.133043 2.99867 0.052521 3.14236 0.0183855C3.18621 0.00672965 3.23138 0.000918879 3.27678 0.000268281C3.33556 -0.00147072 3.3943 0.00519393 3.45064 0.0217385Z" fill="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== style) {
    t2 = <svg className={className} width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>{t1}</svg>;
    $[1] = className;
    $[2] = style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};